// extracted by mini-css-extract-plugin
export default {"objectActionModal":"TrashActions_objectActionModal__gw8+H","objectActionListItem":"TrashActions_objectActionListItem__kQ05Q"};